import { AppDispatch, RootState } from "src/store/store";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import {
  resetToBreadcrumb,
  setBreadcrumb,
} from "src/store/features/breadCrumb";
import { useDispatch, useSelector } from "react-redux";

import ArrowRightIcon from "src/resources/icons/ArrowRightIcon";
import { BreadcrumbElement } from "src/types/commonTypes";
import { EnglishLabels } from "./constants/englishLabels";
import { HindiLabels } from "./constants/hindiLabels";

const DynamicBreadcrumb: React.FC = () => {
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === "HI";
  const breadcrumbs = useSelector((state: RootState) => state.breadcrumb.items);
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  const handleBreadcrumbClick = (path: string) => {
    dispatch(resetToBreadcrumb(path));
  };

  const getBreadcrumbFromPath = (pathname: string) => {
    const parts = pathname.split("/").filter(Boolean);
    const breadcrumbs = parts.map((part, index) => ({
      label: part
        .replace(/-/g, "_")
        .replace(/(^|_)([a-z])/g, (_, p1, p2) => p1 + p2.toUpperCase()),
      path: `/${parts.slice(0, index + 1).join("/")}`,
    }));
    return [{ label: "Home", path: "/" }, ...breadcrumbs];
  };

  // Initialize breadcrumbs on first render or when location changes
  useEffect(() => {
    const initialBreadcrumbs = getBreadcrumbFromPath(location.pathname);
    dispatch(setBreadcrumb(initialBreadcrumbs));
  }, [location.pathname, dispatch]);

  return (
    <Breadcrumb spacing="8px" separator={<ArrowRightIcon />}>
      {breadcrumbs.map((breadcrumb: BreadcrumbElement, index) => (
        <BreadcrumbItem
          key={breadcrumb.path}
          isCurrentPage={index === breadcrumbs.length - 1}
        >
          <BreadcrumbLink
            as={Link}
            to={breadcrumb.path}
            onClick={() => handleBreadcrumbClick(breadcrumb.path)}
          >
            {breadcrumb.label === "Home"
              ? isHindiLabels
                ? HindiLabels.Home_Page
                : EnglishLabels.Home_Page
              : isHindiLabels
              ? HindiLabels[breadcrumb.label as keyof typeof HindiLabels]
              : EnglishLabels[breadcrumb.label as keyof typeof EnglishLabels]}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};

export default DynamicBreadcrumb;
